"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _utils = require("../utils");

var _ArrayFieldItem = _interopRequireDefault(require("./ArrayFieldItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ArrayFieldSortableItem = (0, _reactSortableHoc.sortableElement)(props => {
  const id = props.id,
        idPrefix = props.idPrefix,
        formData = props.formData,
        schema = props.schema,
        uiSchema = props.uiSchema,
        errorSchema = props.errorSchema,
        registry = props.registry,
        itemIndex = props.itemIndex,
        value = props.value;
  const definitions = registry.definitions;
  const itemSchema = (0, _utils.retrieveSchema)(schema.items, definitions, value);
  const itemErrorSchema = errorSchema ? errorSchema[itemIndex] : undefined;
  const itemId = id + "_" + itemIndex;
  const itemIdSchema = (0, _utils.toIdSchema)(itemSchema, itemId, definitions, value, idPrefix);
  const itemData = (0, _utils.getDefaultFormState)(itemSchema, value, definitions);

  const itemUiSchema = _extends({}, uiSchema.items, {
    "ui:draggable": true,
    "ui:draggableHandle": true
  });

  const canRemove = true;
  const canMoveUp = itemIndex > 0;
  const canMoveDown = itemIndex < formData.length - 1;
  return _react.default.createElement(_ArrayFieldItem.default, _extends({}, props, {
    index: itemIndex,
    itemId: itemId,
    itemIdPrefix: itemId,
    canRemove: canRemove,
    canMoveUp: canMoveUp,
    canMoveDown: canMoveDown,
    itemSchema: itemSchema,
    itemUiSchema: itemUiSchema,
    itemIdSchema: itemIdSchema,
    itemErrorSchema: itemErrorSchema,
    itemData: itemData
  }));
});
var _default = ArrayFieldSortableItem;
exports.default = _default;
module.exports = exports.default;